import { render } from "./TheDiscaver.vue?vue&type=template&id=636ef917&scoped=true"
import script from "./TheDiscaver.vue?vue&type=script&lang=js"
export * from "./TheDiscaver.vue?vue&type=script&lang=js"

import "./TheDiscaver.vue?vue&type=style&index=0&id=636ef917&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636ef917"]])

export default __exports__